jQuery(document).ready(function($) {

    const $form = $('.js-alcool-level-calculator');
    const $standardGlasses = $form.find('.js-standard-glasses');
    const $weight = $form.find('.js-weight');
    const $diffusion = $form.find('.js-diffusion');
    const $hours = $form.find('.js-hours');
    const $resultContainer = $form.find('.js-result-container');
    const $result = $form.find('.js-result');
    const $resultTextsContainer = $('.js-result-texts-container');
    const $resultTexts = $resultTextsContainer.find('[class^="js-result-text-"]');

    $form.on('submit', function (e) {
        e.preventDefault();
        updateResult();
        $resultContainer.addClass('active');
    });

    function updateResult() {

        $resultTextsContainer.addClass('active');
        $resultTexts.removeClass('active');

        const standardGlassesNumber = !isNaN(parseFloat($standardGlasses.val())) ? parseFloat($standardGlasses.val()) : 0;
        const weight = !isNaN(parseFloat($weight.val())) ? parseFloat($weight.val()) : 0;
        const diffusion = parseFloat($diffusion.find(":selected").val());
        const hours = !isNaN(parseFloat($hours.val())) ? parseFloat($hours.val()) : 0;

        // grammes d'alcool dans un verre standard  (8 x degré x volume (cl)) / 100, bière 25cl 5%
        const alcoolVolumePerGlass = 8 * 5 * 25 / 100;
        const alcoolVolume = standardGlassesNumber * alcoolVolumePerGlass;
        // Décroissance d'alcoolémie à 0,13 g/h
        const decrease = hours * 0.13;
        // Formule de Widmark
        let total = ( alcoolVolume / (diffusion * weight) ) - decrease;
        total = total < 0 ? 0 : total;
        $result.html(total.toFixed(2) + "‰");


        if ( total <= 0.5 ) {
            $('.js-result-text-1').addClass('active');
        } 
        else if ( ( total > 0.5 ) && ( total < 1.5 ) ) {
            $('.js-result-text-2').addClass('active');
        }
        else if ( ( total >= 1.5 ) && ( total < 3 ) ) {
            $('.js-result-text-3').addClass('active');
        }
        else if ( ( total >= 3 ) && ( total < 4 ) ) {
            $('.js-result-text-4').addClass('active');
        }
        else if ( ( total >= 4 ) && ( total < 5 ) ) {
            $('.js-result-text-5').addClass('active');
        }
        else if ( total >= 0.5 ) {
            $('.js-result-text-6').addClass('active');
        }

        $([document.documentElement, document.body]).animate({
            scrollTop: $("#section-blood-alcool-results").offset().top
        }, 1000);

    }

});